import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH, SUBSCRIBE_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'register-1',
        path: `${AUTH_PREFIX_PATH}/register`,
        component: React.lazy(() => import('views/auth-views/authentication/register-1')),
    },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    },
    {
        key: 'error-page-1',
        path: `${AUTH_PREFIX_PATH}/error-page-1`,
        component: React.lazy(() => import('views/auth-views/errors/error-page-1')),
    },
    {
        key: 'error-page-2',
        path: `${AUTH_PREFIX_PATH}/error-page-2`,
        component: React.lazy(() => import('views/auth-views/errors/error-page-2')),
    },
]

export const protectedRoutes = [
    {
        type: 'admin',
        key: 'admin.coach',
        path:`${APP_PREFIX_PATH}/coach/*`,
        component: React.lazy(() => import('views/app-views/admins/coach')),
    },
    {
        type: 'admin',
        key: 'admin.club',
        path:`${APP_PREFIX_PATH}/club/*`,
        component: React.lazy(() => import('views/app-views/admins/club')),
    },

    {
        type: 'admin',
        key: 'admin.parent',
        path:`${APP_PREFIX_PATH}/parent/*`,
        component: React.lazy(() => import('views/app-views/admins/parent')),
    },

    {
        type: 'admin',
        key: 'admin.player',
        path:`${APP_PREFIX_PATH}/player/*`,
        component: React.lazy(() => import('views/app-views/admins/player')),
    },
    {
        type: 'admin',
        key: 'admin.group',
        path:`${APP_PREFIX_PATH}/group/*`,
        component: React.lazy(() => import('views/app-views/admins/group')),
    },
    {
        type: 'admin',
        key: 'admin.session',
        path:`${APP_PREFIX_PATH}/session/*`,
        component: React.lazy(() => import('views/app-views/admins/session')),
    },
    {
        type: 'admin',
        key: 'admin.category',
        path:`${APP_PREFIX_PATH}/category/*`,
        component: React.lazy(() => import('views/app-views/admins/category')),
    },
    {
        type: 'admin',
        key: 'admin.sport',
        path:`${APP_PREFIX_PATH}/sport/*`,
        component: React.lazy(() => import('views/app-views/admins/sport')),
    },


   
    {
        type: 'admin',
        key: 'admin.push-notification',
        path:`${APP_PREFIX_PATH}/push-notification/*`,
        component: React.lazy(() => import('views/app-views/admins/push-nitification')),
    },
    {
        type: 'admin',
        key: 'admin.faq',
        path:`${APP_PREFIX_PATH}/faq/*`,
        component: React.lazy(() => import('views/app-views/admins/faqs')),
    },
   
    {
        type: 'admin',
        key: 'dashboard.default',
        path: `${APP_PREFIX_PATH}/dashboards/default`,
        component: React.lazy(() => import('views/app-views/dashboards/default')),
    },

    {
        type: 'admin',
        key: 'admin.sport',
        path:`${APP_PREFIX_PATH}/sport/*`,
        component: React.lazy(() => import('views/app-views/admins/sport')),
    },

    {
        type: 'coach',
        key: 'coach.subscribe',
        path: `${APP_PREFIX_PATH}/subscribe/*`,
        component: React.lazy(() => import('views/app-views/subscription/subscribe')),
    },

    {
        type: 'coach',
        key: 'dashboard',
        path: `${APP_PREFIX_PATH}/dashboard/*`,
        component: React.lazy(() => import('views/app-views/subscription/dashboard')),
    },
  
]

// export const subscribeRoutes = [
   
//     {
//         key: 'subscription.subscribe',
//         path: `${SUBSCRIBE_PREFIX_PATH}/subscription/subscribe`,
//         component: React.lazy(() => import('views/app-views/subscription/subscribe')),
//     },
  
// ]